import { TransactionStatusColor } from 'configs/constants';
import {
  formatDisplayAmount,
  formatDisplayDateTime,
  normalizedPhoneNumber,
} from 'utils/helpers';

type FieldConfig = {
  key: string;
  label: string;
  className?: (value: any) => string;
  format?: (value: any) => React.ReactNode;
};

type SectionConfig = {
  key: string;
  label: string;
  getData: (data: any) => any;
  value: FieldConfig[];
};

const formatPhoneNumber = (value: string) =>
  value ? normalizedPhoneNumber(value) : '';

export const dataDefined: SectionConfig[] = [
  {
    key: 'transaction',
    label: 'Thông tin giao dịch',
    getData: (data) => data?.transaction,
    value: [
      {
        key: 'orderCode',
        label: 'Mã đơn hàng',
      },
      {
        key: 'transactionCode',
        label: 'Mã giao dịch',
      },
      {
        key: 'transactionType',
        label: 'Loại giao dịch',
      },
      {
        key: 'serviceType',
        label: 'Loại dịch vụ',
      },
      {
        key: 'status',
        label: 'Trạng thái',
        className: (value) =>
          TransactionStatusColor[
            value as keyof typeof TransactionStatusColor
          ] || '',
      },
      {
        key: 'value',
        label: 'Số tiền',
        format: (value: number) => formatDisplayAmount(value, ''),
      },
      {
        key: 'balanceAfter',
        label: 'Số dư sau giao dịch',
        format: (value: number) => formatDisplayAmount(value, ''),
      },
      {
        key: 'payAt',
        label: 'Thời gian thanh toán',
        format: (value: string) => formatDisplayDateTime(value, ''),
      },
      {
        key: 'requestCancelAt',
        label: 'Thời gian gửi yêu cầu hủy',
        format: (value: string) => formatDisplayDateTime(value, ''),
      },
      {
        key: 'approvedCancelAt',
        label: 'Thời gian duyệt yêu cầu hủy',
        format: (value: string) => formatDisplayDateTime(value, ''),
      },
      {
        key: 'completedCancelAt',
        label: 'Thời gian hủy thành công',
        format: (value: string) => formatDisplayDateTime(value, ''),
      },
    ],
  },
  {
    key: 'execBy',
    label: 'Thông tin người thực hiện',
    getData: (data) => data?.execBy,
    value: [
      {
        key: 'fullName',
        label: 'Tên tài khoản',
      },
      {
        key: 'phoneNumber',
        label: 'Tài khoản',
        format: formatPhoneNumber,
      },
    ],
  },
  {
    key: 'recvBy',
    label: 'Thông tin người nhận',
    getData: (data) => data?.recvBy,
    value: [
      {
        key: 'fullName',
        label: 'Tên tài khoản',
      },
      {
        key: 'phoneNumber',
        label: 'Tài khoản',
        format: formatPhoneNumber,
      },
    ],
  },
  {
    key: 'customer',
    label: 'Thông tin khách hàng',
    getData: (data) => data?.customer,
    value: [
      {
        key: 'customerCode',
        label: 'Mã khách hàng',
      },
      {
        key: 'fullName',
        label: 'Tên khách hàng',
      },
      {
        key: 'address',
        label: 'Địa chỉ',
      },
    ],
  },
  {
    key: 'bank',
    label: 'Thông tin ngân hàng',
    getData: (data) => ({
      ...data?.info?.bank,
      bidvReferenceNo: data?.info?.bidvReferenceNo,
    }),
    value: [
      {
        key: 'bankAccountName',
        label: 'Tên tài khoản',
      },
      {
        key: 'bankAccountNumber',
        label: 'Số tài khoản',
      },
      {
        key: 'name',
        label: 'Ngân hàng',
      },
      {
        key: 'shortName',
        label: 'Tên viết tắt',
      },
      {
        key: 'code',
        label: 'Mã ngân hàng',
      },
      {
        key: 'bidvReferenceNo',
        label: 'Mã tham chiếu BIDV',
      },
    ],
  },
  {
    key: 'merchant',
    label: 'Thông tin đơn vị nhận thanh toán',
    getData: (data) => data?.info?.merchant?.user,
    value: [
      {
        key: 'fullName',
        label: 'Tên tài khoản',
      },
      {
        key: 'phoneNumber',
        label: 'Tài khoản',
        format: formatPhoneNumber,
      },
    ],
  },
];
